export default function AlienInvasionIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="12" fill="#0b0720" />
      <g fill="#ff4fd8">
        <path d="M14 30c0-20 36-20 36 0q-4.5 4-9 0q-4.5 4-9 0q-4.5 4-9 0q-4.5 4-9 0z" />
      </g>
      <g stroke="#ff4fd8" strokeWidth="3" fill="none" strokeLinecap="round">
        <path d="M19 32q-3 4 0 8" />
        <path d="M27 32q3 4 0 8" />
        <path d="M37 32q-3 4 0 8" />
        <path d="M45 32q3 4 0 8" />
      </g>
      <circle cx="26" cy="21" r="4" fill="#fff" />
      <circle cx="38" cy="21" r="4" fill="#fff" />
      <circle cx="26" cy="22" r="2" fill="#140a2e" />
      <circle cx="38" cy="22" r="2" fill="#140a2e" />
      <rect x="31" y="42" width="2.5" height="7" fill="#fff" />
      <ellipse cx="20" cy="56" rx="4" ry="4.5" fill="#ffc23d" />
      <ellipse cx="44" cy="56" rx="4" ry="4.5" fill="#ffc23d" />
      <path d="M21 60q0-8 11-9q11 1 11 9z" fill="#ffc23d" />
      <path d="M28 57a4 4 0 0 1 8 0z" fill="#9ff3ff" />
    </svg>
  );
}
